import { ToolPageShell } from '@/shared/seo'
import { MetadannyePdfForm } from './MetadannyePdfForm'

export function MetadannyePdfPage() {
  return (
    <ToolPageShell utilityKey="pdf-metadata">
      <MetadannyePdfForm />
    </ToolPageShell>
  )
}
